const getBrowserStorage = (type: 'localStorage' | 'sessionStorage'): Storage | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window[type];
  } catch (error) {
    console.error(`Unable to access ${type}:`, error);
    return null;
  }
};

export const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') {
    return null;
  }

  const nameEq = `${name}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');

  for (let cookie of cookieArray) {
    cookie = cookie.trim();
    if (cookie.startsWith(nameEq)) {
      return cookie.substring(nameEq.length);
    }
  }

  return null;
};

export const getAuthToken = (): string | null => {
  const cookieToken = getCookie('accessToken');
  if (cookieToken) {
    return cookieToken;
  }

  const local = getBrowserStorage('localStorage');
  const session = getBrowserStorage('sessionStorage');

  return (
    (local && local.getItem('auth_token')) ||
    (session && session.getItem('auth_token'))
  );
};

export const getCompanySessionId = (): string => {
  const cookieSession = getCookie('company_session_id');
  if (cookieSession) {
    return cookieSession;
  }

  const local = getBrowserStorage('localStorage');
  if (local) {
    const value = local.getItem('company_session_id');
    if (value) {
      return value;
    }
  }

  const session = getBrowserStorage('sessionStorage');
  if (session) {
    const value = session.getItem('company_session_id');
    if (value) {
      return value;
    }
  }

  if (typeof document !== 'undefined') {
    const name = 'company_session_id=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');

    for (let cookie of cookieArray) {
      cookie = cookie.trim();
      if (cookie.startsWith(name)) {
        return cookie.substring(name.length);
      }
    }
  }

  return '';
};
